import { render, staticRenderFns } from "./TwitterFeed.vue?vue&type=template&id=1fe84e7c&"
import script from "./TwitterFeed.vue?vue&type=script&lang=js&"
export * from "./TwitterFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports